
import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Draft = apiContainer.Draft
//GET--->
// Corrected getDraft function
export async function getDraftApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Draft}/order`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
// //CREATE---->
// export async function createDraft(request) {
//     try {
//         return api.create(`${Draft}`, request);
//     } catch (error) {
//         console.error('Fetch error:', error);
//         throw error;
//     }
// }
//UPDATE---->
export async function updateDraft(DraftId) {
    try {
        return api.update(`${Draft}/restore/${DraftId}`, {});
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
// export async function deleteDraft(DraftId) {
//     try {
//         return api.delete(`${Draft}/${DraftId}`);
//     } catch (error) {
//         console.error('Fetch error:', error);
//         throw error;
//     }
// }





